/* eslint-disable react-hooks/exhaustive-deps */
import { memo, useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TextField, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { Button, Modal } from "semantic-ui-react";
import ProfilesByResourceType from "../dictionaries/ProfilesByResourceType";
import { allFhirResourceTypes } from "../dictionaries/CodeSystemLookup";
import { resourceAdded, selectResourceById } from "../slices/resourceCollection/resourceCollectionSlice";
import getSearchResults from "../functions/getSearchResultsAPI";
import { selectCurrentUserApiToken } from "../slices/currentUser/currentUserSlice";
import ArrayEntry from "./ArrayEntry";
import CodeEntry from "./CodeEntry";
import StringEntry from "./StringEntry";
import submitFhirJson from "../functions/submitFhirJsonAPI";
import { displayStringFromFHIRIdentifier } from "./IdentifierEntry";
import RecommendationJustificationEdit from "../components/RecommendationJustificationEdit";
import GroupResourceEdit from "../components/GroupResourceEdit";
import EvidenceVariableResourceEdit from "../components/EvidenceVariableResourceEdit";
import EvidenceResourceEdit from "../components/EvidenceResourceEdit";
import ResearchStudyResourceEdit from "../components/ResearchStudyResourceEdit";
import OutcomeImportanceEdit from "../components/OutcomeImportanceEdit";
import DocumentReferenceResourceEdit from "../components/DocumentReferenceEdit";
import ExpandToAddOrEdit from "../components/ExpandToAddOrEdit";

const submitNewCompositionAndBundle = async (newResource, apiToken) => {
    let title = newResource.title;
    let response = await submitFhirJson(newResource, title, apiToken);
    let resourceFOI;
    if (response?.success) {
        resourceFOI = response.formstateid;
        return resourceFOI;
    }
}

const SelectProfileForNewResource = ({ profileSelectionState, setProfileSelectionState }) => {
    if (!profileSelectionState) {
        console.log("MISSING profileSelectionState");
        return <></>
    } else if (profileSelectionState.profileSelected === "none") {
        return <></>
    } else if (!profileSelectionState.profileChoices) {
        console.log("MISSING profileSelectionState.profileChoices");
        return <></>
    } else if (profileSelectionState.profileChoices.length === 0) {
        console.log("EMPTY profileSelectionState.profileChoices");
        return <></>
    } else {
        const profileDictionary = profileSelectionState.profileDictionary;
        return <div>
            {profileSelectionState.profileChoices.length > 0 && <div style={{ marginLeft: "0px", marginBottom: "8px" }}>
                <br />
                <b>Select a Profile: </b>&nbsp;

                <ToggleButtonGroup
                    className="genericToggleButtonGroup buttonGroupWrap medium"
                    exclusive
                    value={profileSelectionState.profileSelected || ""}
                    aria-label='profile-selection'
                    name='profile-selection'
                >
                    {profileSelectionState.profileChoices.map((profile, profileIndex) => {
                        return <ToggleButton key={profileIndex} className="genericToggleButton" color="primary"
                            aria-label={profile} value={profile}
                            onClick={(e) => {
                                let meta;
                                let section;
                                let content;
                                let profileUrl = "";
                                let citedArtifactClassificationToAdd;
                                let typeValue;
                                let categoryToAdd;
                                let useContextToAdd;
                                let membershipValue;
                                let definitionValue;
                                let actualValue;
                                let handlingValue;
                                let synthesisTypeValue;
                                let combinationMethodValue;
                                let characteristic;
                                let codeValue;
                                if (e.target.value) {
                                    let profileName = e.target.value;
                                    if (profileName === profileSelectionState.profileSelected) {
                                        meta = { "profile": [profileUrl] };
                                        setProfileSelectionState(prevState => {
                                            return {
                                                ...prevState,
                                                'meta': undefined,
                                                'citedArtifactClassificationToAdd': undefined,
                                                'section': undefined,
                                                'content': undefined,
                                                'characteristic': undefined,
                                                'typeValue': undefined,
                                                'categoryToAdd': undefined,
                                                'useContextToAdd': undefined,
                                                'membershipValue': undefined,
                                                'definitionValue': undefined,
                                                'actualValue': undefined,
                                                'handlingValue': undefined,
                                                'synthesisTypeValue': undefined,
                                                'combinationMethodValue': undefined,
                                                'codeValue': undefined,
                                                'profileSelected': undefined
                                            }
                                        });
                                    } else {
                                        if (profileDictionary) {
                                            for (const key in profileDictionary) {
                                                if (key === profileName) {
                                                    profileUrl = profileDictionary[key].url;
                                                    if (profileDictionary[key].citedArtifactClassificationToAdd) {
                                                        citedArtifactClassificationToAdd = profileDictionary[key].citedArtifactClassificationToAdd;
                                                    }
                                                    if (profileDictionary[key].typeValue) {
                                                        typeValue = profileDictionary[key].typeValue;
                                                    }
                                                    if (profileDictionary[key].categoryToAdd) {
                                                        categoryToAdd = profileDictionary[key].categoryToAdd;
                                                    }
                                                    if (profileDictionary[key].useContextToAdd) {
                                                        useContextToAdd = profileDictionary[key].useContextToAdd;
                                                    }
                                                    if (profileDictionary[key].membershipValue) {
                                                        membershipValue = profileDictionary[key].membershipValue;
                                                    }
                                                    if (profileDictionary[key].actualValue === true || profileDictionary[key].actualValue === false) {
                                                        actualValue = profileDictionary[key].actualValue;
                                                    }
                                                    if (profileDictionary[key].handlingValue) {
                                                        handlingValue = profileDictionary[key].handlingValue;
                                                    }
                                                    if (profileDictionary[key].definitionValue) {
                                                        definitionValue = profileDictionary[key].definitionValue;
                                                    }
                                                    if (profileDictionary[key].synthesisTypeValue) {
                                                        synthesisTypeValue = profileDictionary[key].synthesisTypeValue;
                                                    }
                                                    if (profileDictionary[key].combinationMethodValue) {
                                                        combinationMethodValue = profileDictionary[key].combinationMethodValue;
                                                    }
                                                    if (profileDictionary[key].codeValue) {
                                                        codeValue = profileDictionary[key].codeValue;
                                                    }
                                                    if (profileDictionary[key].sectionStarter) {
                                                        section = profileDictionary[key].sectionStarter;
                                                    }
                                                    if (profileDictionary[key].contentStarter) {
                                                        content = profileDictionary[key].contentStarter;
                                                    }
                                                    if (profileDictionary[key].characteristicStarter) {
                                                        characteristic = profileDictionary[key].characteristicStarter;
                                                    }
                                                }
                                            }
                                        }

                                        if (profileUrl) {
                                            meta = { "profile": [profileUrl] };
                                            setProfileSelectionState(prevState => {
                                                return {
                                                    ...prevState,
                                                    'meta': meta,
                                                    'citedArtifactClassificationToAdd': citedArtifactClassificationToAdd,
                                                    'section': section,
                                                    'content': content,
                                                    'characteristic': characteristic,
                                                    'typeValue': typeValue,
                                                    'categoryToAdd': categoryToAdd,
                                                    'useContextToAdd': useContextToAdd,
                                                    'membershipValue': membershipValue,
                                                    'definitionValue': definitionValue,
                                                    'actualValue': actualValue,
                                                    'handlingValue': handlingValue,
                                                    'synthesisTypeValue': synthesisTypeValue,
                                                    'combinationMethodValue': combinationMethodValue,
                                                    'codeValue': codeValue,
                                                    'profileSelected': profileName
                                                }
                                            });
                                        }
                                    }
                                }
                            }}>{profile}</ToggleButton>
                    })}
                </ToggleButtonGroup>
            </div>}
        </div>
    }
}

const SelectResourceFromSearchModal = memo(({ selectedResourceType, allowedResourceTypes,
    setSelectResourceFromSearchState, selectedProfile, allowedProfiles }) => {
    let startingSelectedResourceTypes = null;
    if (allowedResourceTypes) {
        startingSelectedResourceTypes = allowedResourceTypes;
    }
    if (selectedResourceType) {
        startingSelectedResourceTypes = [selectedResourceType];
    }
    let startingSelectedProfiles = null;
    if (allowedProfiles) {
        startingSelectedProfiles = allowedProfiles;
    }
    if (selectedProfile) {
        startingSelectedProfiles = [selectedProfile];
    }
    let startingModalState = { "modalOpen": true, "searchQueryString": "", "searchResults": "" };
    const [modalState, setModalState] = useState(startingModalState);
    const [searchResourceTypeLimiterState, setSearchResourceTypeLimiterState] = useState({
        "selectedResourceType": selectedResourceType,
        "selectedResourceTypes": startingSelectedResourceTypes
    });
    const [searchProfileLimiterState, setSearchProfileLimiterState] = useState({
        "selectedProfile": selectedProfile,
        "selectedProfiles": startingSelectedProfiles
    });
    const apiToken = useSelector(selectCurrentUserApiToken);

    const deliverSearchResults = useCallback(async () => {
        if (modalState.modalOpen && modalState.searchQueryString &&
            modalState.searchQueryCompleted && !modalState.searchResultsDelivered) {
            let searchResults = await getSearchResults(modalState.searchQueryString,
                selectedResourceType,
                searchResourceTypeLimiterState.selectedResourceTypes,
                selectedProfile,
                searchProfileLimiterState.selectedProfiles,
                apiToken);
            setModalState(prevState => {
                return { ...prevState, "searchResults": searchResults, "searchResultsDelivered": true }
            })
        }
    }, [apiToken, modalState, searchResourceTypeLimiterState, selectedResourceType, selectedProfile, searchProfileLimiterState]);

    useEffect((() => {
        deliverSearchResults();
    }), [modalState, deliverSearchResults])

    const selectTheResource = (data) => {
        setModalState(prevState => { return { ...prevState, modalOpen: false }; });
        setSelectResourceFromSearchState(prevState => { return { ...prevState, "selectedResourceReference": data, modalOpen: false }; });
    }

    let modalContent = <div style={{
        paddingTop: "6px", paddingLeft: "20px", paddingRight: "20px",
        paddingBottom: "40px", width: "100%", height: "100%", overflow: "auto"
    }}>
        <Button style={{ padding: "6px", position: "absolute", right: "14px" }} className="formButton negative"
            content="✖"
            onClick={() => {
                setModalState(prevState => { return { ...prevState, modalOpen: false }; });
                setSelectResourceFromSearchState(prevState => { return { ...prevState, modalOpen: false }; });
            }} />
        {(!selectedResourceType) && <>
            <ArrayEntry datatype='code' elementName='selectedResourceTypes' fieldLabel='Limit by Resource Type'
                allowedValues={(allowedResourceTypes && allowedResourceTypes.length) ? allowedResourceTypes : allFhirResourceTypes} dataEntryStyle='dropdownsearch'
                startingValue={searchResourceTypeLimiterState.selectedResourceTypes || []}
                setResourceState={setSearchResourceTypeLimiterState} />
            <p style={{ paddingTop: "12px" }}>Limit to resource types of: {(searchResourceTypeLimiterState.selectedResourceTypes &&
                searchResourceTypeLimiterState.selectedResourceTypes.length > 0) ?
                searchResourceTypeLimiterState.selectedResourceTypes.join(', ') : "[No limits]"}</p>
            <br />
        </>}
        {((selectedResourceType || searchResourceTypeLimiterState?.selectedResourceTypes?.length === 1) &&
            !selectedProfile) && <>
                <ArrayEntry datatype='code' elementName='selectedProfiles' fieldLabel='Limit by Profile'
                    allowedValues={(allowedProfiles && allowedProfiles.length)
                        ?
                        allowedProfiles
                        :
                        ProfilesByResourceType[selectedResourceType ||
                            searchResourceTypeLimiterState.selectedResourceTypes[0]]
                            ?
                            Object.keys(ProfilesByResourceType[selectedResourceType ||
                                searchResourceTypeLimiterState.selectedResourceTypes[0]]
                            )
                            :
                            []}
                    dataEntryStyle='dropdownsearch'
                    startingValue={searchProfileLimiterState.selectedProfiles || []}
                    setResourceState={setSearchProfileLimiterState} />
                <p style={{ paddingTop: "12px" }}>
                    Limit to Profiles of: {(searchProfileLimiterState.selectedProfiles &&
                        searchProfileLimiterState.selectedProfiles.length > 0) ?
                        searchProfileLimiterState.selectedProfiles.join(', ') : "[No limits]"}</p>
                <br />
            </>}
        <h3>Enter search string</h3>
        <TextField style={{ width: "100%", marginTop: "16px" }}
            className="inputField" type='text' label={"Enter search string"} size="small" variant='outlined'
            value={modalState.searchQueryString || ""}
            onKeyUp={(event) => {
                if (event.key === 'Enter') {
                    setModalState(prevState => { return { ...prevState, "searchQueryCompleted": true, "searchResultsDelivered": false } });
                }
            }}
            onChange={(e) => {
                setModalState(prevState => { return { ...prevState, "searchQueryString": e.target.value } })
            }} />
        {modalState.searchResults && <>
            <h3>Select a resource</h3>
            {modalState.searchResults.length > 0
                ?
                <>
                    {modalState.searchResults.map((result, resultIndex) => {
                        return <p key={resultIndex}>
                            <span style={{ cursor: "pointer" }} onClick={() => { selectTheResource(result.data); }} ><b>SELECT</b></span>
                            &nbsp;&nbsp;
                            <span >{result.display}</span>
                            &nbsp;&nbsp;
                            <a href={"https://fevir.net" + result.onClick} target='_blank' rel='noopener noreferrer' >View on FEvIR</a>
                        </p>
                    })}
                </>
                :
                <>No results found.</>}
        </>
        }
        <br />
    </div>;

    return <Modal
        style={{ padding: "0px", margin: "0px" }}
        dimmer={<Modal.Dimmer style={{ backgroundColor: "#00000077" }} />}
        open={modalState?.modalOpen}
        centered={false}
        content={modalContent}
    />;
})

const ReferencedResourceContentEntry = ({ referencedResourceJsonState }) => {
    let resourceType = referencedResourceJsonState.resourceType;

    if (resourceType === "Group" || resourceType === "EvidenceVariable" ||
        resourceType === "Evidence" || resourceType === "ResearchStudy" ||
        resourceType === "DocumentReference") {
        return <div>
            <h4>Change the content for this {resourceType} Resource.</h4>
            <div style={{ marginLeft: "24px", padding: "6px", outline: "2px solid #444444", borderRadius: "8px", backgroundColor: "#FFFFB0" }}>
                {resourceType === "Group" &&
                    <GroupResourceEdit foi={referencedResourceJsonState.id} />}
                {resourceType === "EvidenceVariable" &&
                    <EvidenceVariableResourceEdit foi={referencedResourceJsonState.id} />}
                {resourceType === "Evidence" &&
                    <EvidenceResourceEdit foi={referencedResourceJsonState.id} />}
                {resourceType === "ResearchStudy" &&
                    <ResearchStudyResourceEdit foi={referencedResourceJsonState.id} />}
                {resourceType === "DocumentReference" &&
                    <DocumentReferenceResourceEdit foi={referencedResourceJsonState.id} />}
            </div>
            <br />
        </div>
    } else if (resourceType === "ArtifactAssessment" &&
        referencedResourceJsonState?.meta?.profile?.[0] === "http://hl7.org/fhir/uv/ebm/StructureDefinition/recommendation-justification"
    ) {
        return <div>
            <h4>Change the content for this RecommendationJustification Resource.</h4>
            <div style={{ marginLeft: "24px", padding: "6px", outline: "2px solid #444444", borderRadius: "8px", backgroundColor: "#FFFFB0" }}>
                <RecommendationJustificationEdit foi={referencedResourceJsonState.id} />
            </div>
            <br />
        </div>
    } else if (resourceType === "ArtifactAssessment" &&
        referencedResourceJsonState?.meta?.profile?.[0] === "http://hl7.org/fhir/uv/ebm/StructureDefinition/outcome-importance"
    ) {
        return <div>
            <h4>Change the content for this OutcomeImportance Resource.</h4>
            <div style={{ marginLeft: "24px", padding: "6px", outline: "2px solid #444444", borderRadius: "8px", backgroundColor: "#FFFFB0" }}>
                <OutcomeImportanceEdit foi={referencedResourceJsonState.id} />
            </div>
            <br />
        </div>
    } else {
        return <p>THIS WILL BE FORM FOR EDITING RESOURCE CONTENT</p>
    }
};

const createNewReferencedResource = (title, resourceType, profileSelectionState, addElementValues) => {

    let newResource = {
        "resourceType": resourceType,
        "meta": profileSelectionState.meta || {},
        "title": title,
        "status": "active"
    };

    if (profileSelectionState.typeValue) {
        newResource.type = profileSelectionState.typeValue;
    }
    if (profileSelectionState.categoryToAdd) {
        newResource.category = [profileSelectionState.categoryToAdd];
    }
    if (profileSelectionState.useContextToAdd) {
        newResource.useContext = [profileSelectionState.useContextToAdd];
    }
    if (profileSelectionState.membershipValue) {
        newResource.membership = profileSelectionState.membershipValue;
    }
    if (profileSelectionState.definitionValue) {
        newResource.definition = profileSelectionState.definitionValue;
    }
    if (profileSelectionState.actualValue === true || profileSelectionState.actualValue === false) {
        newResource.actual = profileSelectionState.actualValue;
    }
    if (profileSelectionState.handlingValue) {
        newResource.handling = profileSelectionState.handlingValue;
    }
    if (profileSelectionState.synthesisTypeValue) {
        newResource.synthesisType = profileSelectionState.synthesisTypeValue;
    }
    if (profileSelectionState.combinationMethodValue) {
        newResource.combinationMethod = profileSelectionState.combinationMethodValue;
    }
    if (profileSelectionState.codeValue) {
        newResource.code = profileSelectionState.codeValue;
    }
    if (profileSelectionState.section) {
        newResource.section = profileSelectionState.section;
    } else if (resourceType === "Composition") {
        newResource.section = [];
    }
    if (profileSelectionState.content) {
        newResource.content = profileSelectionState.content;
    }
    if (profileSelectionState.characteristic) {
        newResource.characteristic = profileSelectionState.characteristic;
    }

    if (resourceType === "Composition") {
        newResource.status = "final";
    } else if (resourceType === "CodeSystem") {
        newResource.concept = [];
    } else if (resourceType === "List") {
        newResource.status = "current";
    } else if (resourceType === "Citation" && profileSelectionState.citedArtifactClassificationToAdd) {
        newResource.citedArtifact = { classification: [profileSelectionState.citedArtifactClassificationToAdd] };
    }

    if (addElementValues) {
        for (const key in addElementValues) {
            if (addElementValues[key] || addElementValues[key] === false) {
                if (key === "relatedArtifact" && resourceType === "Composition") {
                    newResource["relatesTo"] = addElementValues[key];
                } else if (resourceType !== "List") {
                    newResource[key] = addElementValues[key];
                }
                if (!title && key === "title") {
                    title = newResource.title;
                }
            }
        }
    }
    return newResource;
};

const DisplayFromFHIRReference = ({ reference }) => {
    if (!reference) {
        return <></>
    }
    if (Array.isArray(reference) || typeof reference !== "object") {
        return <>[ERROR: Reference data not interpretable.]</>;
    }
    let referenceRef = reference.reference;
    let display = reference.display || referenceRef;
    if (referenceRef?.split("/").length === 2) {
        referenceRef = "https://fevir.net/resources/" + referenceRef;
    }
    if (referenceRef) {
        if (reference.type === "Composition") {
            return <span>
                <a href={referenceRef.replace("https://fevir.net/resources/", "https://computablepublishing.com/")}
                    target='_blank' rel='noopener noreferrer'>{display}</a>
                <span> or on </span><a href={referenceRef}
                    target='_blank' rel='noopener noreferrer'>FEvIR Platform</a>
            </span>
        } else {
            return <span>
                <a href={referenceRef} target='_blank' rel='noopener noreferrer'>{display} (on FEvIR Platform)</a>
            </span>
        }
    }
    return <span>{display}</span>
}

const displayStringFromFHIRReference = (reference) => {
    if (reference === undefined || reference === null || reference === '') {
        return ""
    }
    if (typeof reference === "object") {
        let referenceDisplay = reference.display || reference.reference || displayStringFromFHIRIdentifier(reference.identifier) || "";
        if (typeof referenceDisplay === "string" && referenceDisplay !== "") {
            return referenceDisplay;
        }
        if (reference.type) {
            return "[No data for " + reference.type + " Resource.]";
        }
    }
    if (typeof reference === "string") {
        return `${reference} [ERROR: Reference data not in expected Reference datatype.]`
    }
    return "[ERROR: Reference data not interpretable.]";
}

const ReferenceEntry = memo(({ elementName, fieldLabel, startingValue, setResourceState,
    enableCreation, referencedResourceTypes, startCollapsed, doNotShowFieldLabel,
    startingResourceType, setProfile, selectProfile, selectAnyProfile, addElementValues }) => {
    //console.log("ReferenceEntry CALLED AGAIN");
    const dispatch = useDispatch();
    const calculateStartingReference = useCallback((startingValue) => {
        let startingReference = { "reference": "", "type": "", "identifier": "", "display": "" };
        if (!startingValue) {
            startingValue = "";
        } else {
            if (startingValue.extension) { startingReference.extension = startingValue.extension; }
            if (startingValue.reference) { startingReference.reference = startingValue.reference; }
            if (startingValue.type) { startingReference.type = startingValue.type; }
            if (startingValue.identifier) { startingReference.identifier = startingValue.identifier; }
            if (startingValue.display) { startingReference.display = startingValue.display; }
            if (!startingReference.display && addElementValues) {
                startingReference.display = addElementValues.title || addElementValues.name || "";
            }
        }
        return startingReference;
    }, [addElementValues]);
    const startingReference = useMemo(() => calculateStartingReference(startingValue), [startingValue, calculateStartingReference]);

    let startingProfileSelectionState = { "profileChoices": [] };
    if (startingResourceType && (setProfile || selectAnyProfile || selectProfile)) {
        const profileDictionary = ProfilesByResourceType[startingResourceType];
        const profileNames = Object.keys(profileDictionary);
        if (profileDictionary) {
            if (setProfile) {
                if (profileNames.includes(setProfile)) {
                    let meta;
                    let section;
                    let content;
                    let profileUrl = "";
                    let citedArtifactClassificationToAdd;
                    let typeValue;
                    let categoryToAdd;
                    let useContextToAdd;
                    let membershipValue;
                    let actualValue;
                    let handlingValue;
                    let definitionValue;
                    let synthesisTypeValue;
                    let combinationMethodValue;
                    let characteristic;
                    let codeValue;
                    let additionalProfiles;
                    if (profileDictionary[setProfile]) {
                        profileUrl = profileDictionary[setProfile].url;
                        if (profileDictionary[setProfile].citedArtifactClassificationToAdd) {
                            citedArtifactClassificationToAdd = profileDictionary[setProfile].citedArtifactClassificationToAdd;
                        }
                        if (profileDictionary[setProfile].typeValue) {
                            typeValue = profileDictionary[setProfile].typeValue;
                        }
                        if (profileDictionary[setProfile].categoryToAdd) {
                            categoryToAdd = profileDictionary[setProfile].categoryToAdd;
                        }
                        if (profileDictionary[setProfile].useContextToAdd) {
                            useContextToAdd = profileDictionary[setProfile].useContextToAdd;
                        }
                        if (profileDictionary[setProfile].membershipValue) {
                            membershipValue = profileDictionary[setProfile].membershipValue;
                        }
                        if (profileDictionary[setProfile].definitionValue) {
                            definitionValue = profileDictionary[setProfile].definitionValue;
                        }
                        if (profileDictionary[setProfile].actualValue === true || profileDictionary[setProfile].actualValue === false) {
                            actualValue = profileDictionary[setProfile].actualValue;
                        }
                        if (profileDictionary[setProfile].handlingValue) {
                            handlingValue = profileDictionary[setProfile].handlingValue;
                        }
                        if (profileDictionary[setProfile].synthesisTypeValue) {
                            synthesisTypeValue = profileDictionary[setProfile].synthesisTypeValue;
                        }
                        if (profileDictionary[setProfile].combinationMethodValue) {
                            combinationMethodValue = profileDictionary[setProfile].combinationMethodValue;
                        }
                        if (profileDictionary[setProfile].codeValue) {
                            codeValue = profileDictionary[setProfile].codeValue;
                        }
                        if (profileDictionary[setProfile].sectionStarter) {
                            section = profileDictionary[setProfile].sectionStarter;
                        }
                        if (profileDictionary[setProfile].contentStarter) {
                            content = profileDictionary[setProfile].contentStarter;
                        }
                        if (profileDictionary[setProfile].characteristicStarter) {
                            characteristic = profileDictionary[setProfile].characteristicStarter;
                        }
                        if (profileDictionary[setProfile].additionalProfiles) {
                            additionalProfiles = profileDictionary[setProfile].additionalProfiles;
                        }
                    }
                    if (profileUrl) {
                        meta = { "profile": [profileUrl] };
                        if (additionalProfiles) {
                            meta.profile = meta.profile.concat(additionalProfiles);
                        }
                        startingProfileSelectionState = {
                            "profileChoices": [setProfile], "profileDictionary": profileDictionary,
                            'meta': meta,
                            'citedArtifactClassificationToAdd': citedArtifactClassificationToAdd,
                            'section': section,
                            'content': content,
                            'characteristic': characteristic,
                            'typeValue': typeValue,
                            'categoryToAdd': categoryToAdd,
                            'useContextToAdd': useContextToAdd,
                            'membershipValue': membershipValue,
                            'definitionValue': definitionValue,
                            'actualValue': actualValue,
                            'handlingValue': handlingValue,
                            'synthesisTypeValue': synthesisTypeValue,
                            'combinationMethodValue': combinationMethodValue,
                            'codeValue': codeValue,
                            "profileSelected": setProfile
                        };
                    }
                }
            } else {
                let profileChoices = [];
                if (selectAnyProfile) {
                    profileChoices = profileNames;
                }
                if (selectProfile) {
                    for (const item of selectProfile) {
                        if (profileNames.includes(item)) {
                            profileChoices.push(item);
                        }
                    }
                }
                if (profileChoices.length === 0) {
                    console.log('profileChoices.length = 0');
                    startingProfileSelectionState = { "profileSelected": "none" };
                } else if (profileChoices.length === 1) {
                    startingProfileSelectionState = {
                        "profileChoices": profileChoices, "profileDictionary": profileDictionary,
                        "profileSelected": profileChoices[0]
                    };
                } else if (profileChoices.length > 1) {
                    startingProfileSelectionState = { "profileChoices": profileChoices, "profileDictionary": profileDictionary };
                }
            }
        }
    }

    const [referenceState, setReferenceState] = useState(JSON.parse(JSON.stringify(startingReference || {})));
    const [startCollapsedState, setStartCollapsedState] = useState(startCollapsed)
    const [selectResourceFromSearchState, setSelectResourceFromSearchState] = useState({});
    const [newResourceFoiState, setNewResourceFoiState] = useState("");
    const [referencedResourceJsonState, setReferencedResourceJsonState] = useState("");
    const [profileSelectionState, setProfileSelectionState] = useState(startingProfileSelectionState);
    const [editResourceContentState, setEditResourceContentState] = useState(false);
    const [referencedFoiState, setReferencedFoiState] = useState(null);

    const parentResourceDetail = useSelector(state => selectResourceById(state, referencedFoiState));

    const apiToken = useSelector(selectCurrentUserApiToken);

    useEffect(() => {
        if (referencedFoiState && parentResourceDetail) {
            let referencedResourceJson = parentResourceDetail.revisedResourceJson;
            if (referencedResourceJson) {
                setReferencedResourceJsonState(referencedResourceJson);
            }
        }
    }, [referencedFoiState, parentResourceDetail?.revisedResourceJson])

    useEffect((() => {
        if (setProfile && startingResourceType) {
            if (!referenceState.type) {
                setReferenceState(prevState => { return { ...prevState, 'type': startingResourceType } });
            }
        }
    }), [setProfile, startingResourceType, referenceState.type]);

    useEffect((() => {
        if (referenceState.reference?.split("/").length === 2) {
            let presumedFoi = referenceState.reference.split("/")[1];
            if (!isNaN(presumedFoi)) {
                setReferencedFoiState(presumedFoi);
            }
        }
    }), [referenceState.reference]);

    useEffect((() => {
        if (referenceState.type) {
            let profileChoices;
            if (selectAnyProfile || selectProfile) {
                const profileDictionary = ProfilesByResourceType[referenceState.type];
                if (profileDictionary) {
                    profileChoices = [];
                    const profileNames = Object.keys(profileDictionary);
                    if (selectAnyProfile) {
                        profileChoices = profileNames;
                    }
                    if (selectProfile) {
                        for (const item of selectProfile) {
                            if (profileNames.includes(item)) {
                                profileChoices.push(item);
                            }
                        }
                    }
                    if (profileChoices.length === 0) {
                        //profileChoices = null;
                        console.log('profileChoices.length = 0');
                        setProfileSelectionState({ "profileChoices": [], "profileSelected": "none" });
                    } else if (profileChoices.length === 1) {
                        setProfileSelectionState({
                            "profileChoices": profileChoices, "profileDictionary": profileDictionary,
                            "profileSelected": profileChoices[0]
                        });
                    } else if (profileChoices.length > 1) {
                        setProfileSelectionState({ "profileChoices": profileChoices, "profileDictionary": profileDictionary });
                    }
                } else {
                    setProfileSelectionState({ "profileChoices": [], "profileSelected": "none" });
                }
            }
        }
    }), [referenceState.type, selectAnyProfile, selectProfile]);

    useEffect((() => {
        if (selectResourceFromSearchState.selectedResourceReference) {
            setReferenceState(selectResourceFromSearchState.selectedResourceReference);
        }
    }), [selectResourceFromSearchState.selectedResourceReference])

    useEffect((() => {
        if (Object.keys(referenceState).length &&
            JSON.stringify(startingReference) !== JSON.stringify(referenceState)) {
            let newReference = {};
            if (referenceState.extension) { newReference.extension = referenceState.extension; }
            if (referenceState.reference) { newReference.reference = referenceState.reference; }
            if (referenceState.type) { newReference.type = referenceState.type; }
            if (referenceState.identifier && Object.keys(referenceState.identifier).length) {
                newReference.identifier = referenceState.identifier;
            }
            if (referenceState.display) {
                newReference.display = referenceState.display;
            } else if (addElementValues) {
                newReference.display = addElementValues.title || addElementValues.name || "";
            }
            if (Object.keys(newReference).length === 0 || (!newReference.display && !newReference.reference && !newReference.identifier && !newReference.extension)) {
                newReference = null;
            }
            setResourceState(prevState => { return { ...prevState, [elementName]: newReference } });
        }
    }), [referenceState]);

    if (startCollapsedState) {
        return <>
            <div>
                {!doNotShowFieldLabel && <b>{fieldLabel}: </b>}
                {startingValue && <DisplayFromFHIRReference reference={startingReference} />}
                &nbsp;&nbsp;
                <ExpandToAddOrEdit startingValue={startingValue} setStartCollapsedState={setStartCollapsedState} />
                &nbsp;&nbsp;
                {(enableCreation && (referenceState.reference || referenceState.identifier) &&
                    referencedResourceJsonState) &&
                    <>
                        <Button className="formButton" style={{ color: "#FFFFFF" }}
                            positive={true}
                            content={`Edit the Resource Content`} disabled={editResourceContentState}
                            onClick={() => {
                                setStartCollapsedState(false);
                                setEditResourceContentState(true);
                            }} />
                        <br /></>
                }
            </div>
        </>
    } else {
        if (!referenceState.display && !referenceState.reference && !referenceState.identifier) {
            return <>
                {(fieldLabel && !doNotShowFieldLabel) && <p style={{ marginBottom: "2px" }}><b>{fieldLabel}: </b></p>}
                <div style={{ marginLeft: "24px" }}>
                    <StringEntry elementName='display' fieldLabel={'Title of ' + fieldLabel}
                        startingValue={referenceState.display || addElementValues?.title} setResourceState={setReferenceState} />
                    <Button className="formButton" style={{ color: "#000000" }}
                        content="Search Resources to Select One"
                        onClick={() => { setSelectResourceFromSearchState({ "modalOpen": true }); }} />
                    <br />
                    <span>or enter reference value: <StringEntry elementName='reference'
                        fieldLabel='Referenced resource absolute or relative URI'
                        startingValue={referenceState.reference} setResourceState={setReferenceState} />
                    </span>
                </div>
                {selectResourceFromSearchState.modalOpen &&
                    <SelectResourceFromSearchModal selectedResourceType={referenceState.type}
                        allowedResourceTypes={referencedResourceTypes}
                        setSelectResourceFromSearchState={setSelectResourceFromSearchState} />}
            </>
        } else {
            if (enableCreation) {
                return <>
                    {(fieldLabel && !doNotShowFieldLabel) &&
                        <p style={{ marginBottom: "0px" }}><b>{fieldLabel}: </b></p>}
                    <div style={{ marginLeft: "24px" }}>
                        <StringEntry elementName='display' fieldLabel={'Title of ' + fieldLabel + ' Resource'}
                            startingValue={referenceState.display || addElementValues?.title} setResourceState={setReferenceState} />
                        {(profileSelectionState.showProfileSelector && profileSelectionState.profileSelected !== "none") &&
                            <SelectProfileForNewResource profileSelectionState={profileSelectionState}
                                setProfileSelectionState={setProfileSelectionState} />}
                        {referencedResourceTypes?.length ?
                            <CodeEntry elementName='type' fieldLabel='Resource Type' startingValue={referenceState.type} setResourceState={setReferenceState}
                                allowedValues={referencedResourceTypes} />
                            :
                            <CodeEntry elementName='type' fieldLabel='Resource Type' startingValue={referenceState.type}
                                allowedValues={allFhirResourceTypes} dataEntryStyle="dropdownsearch"
                                setResourceState={setReferenceState} />
                        }
                        {(referenceState.reference || referenceState.identifier) ?
                            <>
                                {referencedResourceJsonState &&
                                    <>
                                        <Button className="formButton" style={{ color: "#FFFFFF" }}
                                            positive={true}
                                            content={`Edit Resource Content`} disabled={editResourceContentState}
                                            onClick={() => {
                                                setEditResourceContentState(true);
                                            }} />
                                        &nbsp;&nbsp;&nbsp;
                                        {referencedResourceJsonState.id && <span>
                                            <a href={'https://fevir.net/' + referencedResourceJsonState.id}
                                                target='_blank' rel='noopener noreferrer' >Edit this Resource on FEvIR Platform</a>
                                        </span>}
                                        {editResourceContentState &&
                                            <ReferencedResourceContentEntry
                                                referencedResourceJsonState={referencedResourceJsonState} />}
                                        <br />
                                    </>}
                                {((profileSelectionState.profileChoices?.length || selectAnyProfile || selectProfile) &&
                                    !profileSelectionState.profileSelected && !setProfile && profileSelectionState.profileSelected !== "none") ?
                                    <Button className="formButton" style={{ color: "#000000" }}
                                        content={`Select Profile to replace with new ${startingResourceType || referenceState.type} Resource`}
                                        onClick={() => {
                                            setProfileSelectionState(prevState => {
                                                return {
                                                    ...prevState,
                                                    showProfileSelector: true
                                                };
                                            });
                                        }} />
                                    :
                                    <Button className="formButton" style={{ color: "#000000" }}
                                        content={`Replace with new ${startingResourceType || referenceState.type || "[MUST SELECT A TYPE FIRST]"} Resource`}
                                        onClick={async () => {
                                            let newResource = createNewReferencedResource(referenceState.display,
                                                startingResourceType || referenceState.type, profileSelectionState, addElementValues);

                                            let title = referenceState.display;

                                            let resourceFOI;

                                            if (newResource.resourceType === "Composition") {
                                                resourceFOI = await submitNewCompositionAndBundle(newResource, apiToken);
                                                newResource.id = resourceFOI;
                                                let resourceBody = {
                                                    id: resourceFOI,
                                                    displayTitle: newResource.title,
                                                    productFamily: "",
                                                    parentProductFOI: "",
                                                    resourceType: newResource.resourceType,
                                                    resourceJson: newResource,
                                                    revisedResourceJson: newResource
                                                }
                                                dispatch(resourceAdded(resourceBody));
                                            } else {
                                                let response = await submitFhirJson(newResource, title, apiToken);
                                                if (response?.success) {
                                                    resourceFOI = response.formstateid;
                                                    newResource.id = resourceFOI;
                                                    let resourceBody = {
                                                        id: resourceFOI,
                                                        displayTitle: title,
                                                        productFamily: "",
                                                        parentProductFOI: "",
                                                        resourceType: newResource.resourceType,
                                                        resourceJson: newResource,
                                                        revisedResourceJson: newResource
                                                    }
                                                    dispatch(resourceAdded(resourceBody));
                                                }
                                            }
                                            setNewResourceFoiState(resourceFOI);
                                            setReferenceState(prevState => {
                                                let reference = `${startingResourceType || referenceState.type}/${resourceFOI}`;
                                                return {
                                                    ...prevState,
                                                    reference: reference,
                                                    type: startingResourceType || referenceState.type
                                                };
                                            });
                                        }} />
                                }
                                &nbsp;&nbsp;&nbsp;
                                {(newResourceFoiState && !referencedResourceJsonState) && <span>
                                    <a href={'https://fevir.net/' + newResourceFoiState}
                                        target='_blank' rel='noopener noreferrer' >Edit this new Resource on FEvIR Platform</a>
                                </span>}
                                <br /></>
                            :
                            <>
                                {((profileSelectionState.profileChoices?.length || selectAnyProfile || selectProfile) &&
                                    !profileSelectionState.profileSelected && !setProfile && profileSelectionState.profileSelected !== "none") ?
                                    <Button className="formButton" style={{ color: "#000000" }}
                                        content={`Select Profile to create this new ${startingResourceType || referenceState.type} Resource`}
                                        onClick={() => {
                                            setProfileSelectionState(prevState => {
                                                return {
                                                    ...prevState,
                                                    showProfileSelector: true
                                                };
                                            });
                                        }} />
                                    :
                                    <Button className="formButton" style={{ color: "#FFFFFF" }}
                                        positive={true}
                                        content={`Create this ${startingResourceType || referenceState.type || "[MUST SELECT A TYPE FIRST]"} Resource`}
                                        onClick={async () => {
                                            let newResource = createNewReferencedResource(referenceState.display,
                                                startingResourceType || referenceState.type, profileSelectionState, addElementValues);

                                            let title = referenceState.display;
                                            let resourceFOI;
                                            if (newResource.resourceType === "Composition") {
                                                resourceFOI = await submitNewCompositionAndBundle(newResource, apiToken);
                                            } else {
                                                console.log(title)
                                                let response = await submitFhirJson(newResource, title, apiToken);
                                                if (response?.success) {
                                                    console.log(response)
                                                    resourceFOI = response.formstateid;
                                                    newResource.id = resourceFOI;
                                                    console.log(resourceFOI)
                                                    let resourceBody = {
                                                        id: resourceFOI,
                                                        displayTitle: title,
                                                        productFamily: "",
                                                        parentProductFOI: "",
                                                        resourceType: newResource.resourceType,
                                                        resourceJson: newResource,
                                                        revisedResourceJson: newResource
                                                    }
                                                    dispatch(resourceAdded(resourceBody));
                                                }
                                            }

                                            setNewResourceFoiState(resourceFOI);
                                            setReferenceState(prevState => {
                                                let reference = `${startingResourceType || referenceState.type}/${resourceFOI}`;
                                                return {
                                                    ...prevState,
                                                    reference: reference,
                                                    type: startingResourceType || referenceState.type
                                                };
                                            });
                                        }} />
                                }
                                <br /></>}
                        <Button className="formButton" style={{ color: "#000000" }}
                            content="Search Resources to Select One"
                            onClick={() => { setSelectResourceFromSearchState({ "modalOpen": true }); }} />
                        <br />
                        <span>or enter reference value: <StringEntry elementName='reference'
                            fieldLabel='Referenced resource absolute or relative URI'
                            startingValue={referenceState.reference} setResourceState={setReferenceState} />
                        </span>
                    </div>
                    {selectResourceFromSearchState.modalOpen &&
                        <SelectResourceFromSearchModal selectedResourceType={referenceState.type}
                            allowedResourceTypes={referencedResourceTypes}
                            setSelectResourceFromSearchState={setSelectResourceFromSearchState} />}
                </>
            } else {
                return <>
                    {(fieldLabel && !doNotShowFieldLabel) &&
                        <p style={{ marginBottom: "2px" }}><b>{fieldLabel}: </b></p>}
                    <div style={{ marginLeft: "24px" }}>
                        <StringEntry elementName='display' fieldLabel={'Title of ' + fieldLabel}
                            startingValue={referenceState.display || addElementValues?.title} setResourceState={setReferenceState} />
                        {referencedResourceTypes ?
                            <CodeEntry elementName='type' fieldLabel='Resource Type' startingValue={referenceState.type} setResourceState={setReferenceState}
                                allowedValues={referencedResourceTypes} />
                            :
                            <StringEntry elementName='type' fieldLabel='Resource Type' startingValue={referenceState.type} setResourceState={setReferenceState} />
                        }
                        <br />
                        <Button className="formButton" style={{ color: "#000000" }}
                            content="Search Resources to Select One"
                            onClick={() => { setSelectResourceFromSearchState({ "modalOpen": true }); }} />
                        <br />
                        <span>or enter reference value: <StringEntry elementName='reference'
                            fieldLabel='Referenced resource absolute or relative URI'
                            startingValue={referenceState.reference} setResourceState={setReferenceState} />
                        </span>
                    </div>
                    {selectResourceFromSearchState.modalOpen &&
                        <SelectResourceFromSearchModal selectedResourceType={referenceState.type}
                            allowedResourceTypes={referencedResourceTypes}
                            setSelectResourceFromSearchState={setSelectResourceFromSearchState} />}
                </>
            }
        }
    }
})

export default ReferenceEntry;
export { DisplayFromFHIRReference, displayStringFromFHIRReference, submitNewCompositionAndBundle, SelectResourceFromSearchModal };